export default __webpack_public_path__ + "static/char-s-12-kr-ea55e45e7b0af659c7bc0f289fa22334.webp";